import PaymentStatus from './PaymentStatus';

export default PaymentStatus;
